import { render, staticRenderFns } from "./HorizontalScroll.vue?vue&type=template&id=2b62e11d&"
import script from "./HorizontalScroll.vue?vue&type=script&lang=js&"
export * from "./HorizontalScroll.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalScroll.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports